<template>
    <div class="navbar">
    <div class="container">
      <a href="/" class="logo">
        <img :src="require('../assets/logo_white.svg')" alt="Logo" class="logo-svg">
      </a>
      <nav>
        <ul>
          <li><a href="/">Home</a></li>
          <li><a href="#">About</a></li>
        </ul>
      </nav>
    </div>
  </div>
  </template>
  
  <script>
  export default {
    name: 'NavigationBar',
  };
  </script>
  
  <style scoped>
  /* Add custom styles here if needed */
  /* Reset some default styles */
/* body, ul, li {
  margin: 0;
  padding: 0 20px;
  list-style: none;
} */

.navbar {
  position: relative;
  background-color: #0099cc;
  /* color: #fff; */
  padding: 0;
  margin: 0;
  width: 100%;
}

/* Style the navigation bar */
.logo-svg{
  width: 60px; /* Adjust the width as needed */
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 3000px;
  margin: 0 10px;
  padding: 0 20px;
}

/* Style the logo */
.logo {
  font-size: 24px;
  font-weight: bold;
  text-decoration: none;
  color: #fff;
}

/* Style the navigation menu */
nav ul {
  display: flex;
}

nav ul li {
  margin-right: 20px;
}

nav ul li:last-child {
  margin-right: 0;
}

nav ul li a {
  text-decoration: none;
  color: #fff;
  font-weight: bold;
}

/* Hover effect for navigation links */
nav ul li a:hover {
  color: #000;
}

  </style>
  